import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "D:/work/BC_Supermarket/bc-supermarket-docs-docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { LeftHeaderContentBuilderComponent, RightHeaderContentBuilderComponent, BannerBelowHeaderBuilderComponent, ThreeBannersBelowHeaderBuilderComponent } from '@tvlgiao/bc-supermarket-builder-components';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<h1 {...{
      "id": "header"
    }}>{`Header`}</h1>
<h2 {...{
      "id": "header-styles"
    }}>{`Header Styles`}</h2>
<p>{`Theme supports 3 different header styles:`}</p>
<ul>
<li parentName="ul">{`Logo at left`}</li>
<li parentName="ul">{`Logo at center`}</li>
<li parentName="ul">{`Logo at right`}</li>
</ul>
<p><img alt="Header Logo at left" src={require("../img/home1-header-left.png")} /></p>
<p><img alt="Header Logo at center" src={require("../img/home1-header-center.png")} /></p>
<p><img alt="Header Logo at right" src={require("../img/home1-header-right.png")} /></p>
<p>{`To configure it, open the `}<strong parentName="p">{`Theme Editor`}</strong>{`, scroll down to `}<strong parentName="p">{`Logo`}</strong>{` section, click to expand Logo options, choose `}<strong parentName="p">{`Logo position`}</strong>{` as you wish.`}</p>
<p><img alt="Change logo position" src={require("../img/change-logo-position.png")} /></p>
<h2 {...{
      "id": "welcome-text"
    }}>{`Welcome Text`}</h2>
<p><img alt="Welcome text" src={require("../img/home1-welcome-text.png")} /></p>
<p>{`The welcome text can be showed in `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Header`}</strong>{` > tick on `}<strong parentName="p">{`Show welcome text`}</strong></p>
<p><img alt="Toggle show/hide welcome text" src={require("../img/theme-editor-show-welcome-text.png")} /></p>
<p>{`You can edit the text in the language file `}<inlineCode parentName="p">{`lang/en.json`}</inlineCode>{` in `}<strong parentName="p">{`Edit Theme Files`}</strong>{`:`}</p>
<p><img alt="Edit language for welcome text" src={require("../img/edit-language-welcome-text.png")} /></p>
<h2 {...{
      "id": "phone-number--store-address"
    }}>{`Phone Number & Store Address`}</h2>
<p><img alt="Header info text" src={require("../img/home1-infobar.png")} /></p>
<p>{`Your store address and phone number are pulled out from `}<strong parentName="p">{`Store Profile`}</strong>{`. You can edit it in `}<strong parentName="p">{`Store Setup`}</strong>{` > `}<strong parentName="p">{`Store Profile`}</strong>{`:`}</p>
<p><img alt="Edit Store Address and Phone" src={require("../img/edit-store-address-phone.png")} /></p>
<h2 {...{
      "id": "promotion-content-on-the-header-left"
    }}>{`Promotion content on the header left`}</h2>
<p><img alt="Promotion content on top left of header" src={require("../img/promo-text-on-top-left-header.png")} /></p>
<p>{`To display the custom text at this position, go to `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Header`}</strong>{`, tick on `}<strong parentName="p">{`Show custom content after welcome text`}</strong>{`, save & publish:`}</p>
<p><img alt="Theme editor - show custom content after welcome text" src={require("../img/theme-editor-show-promo-text-on-top-left-header.png")} /></p>
<p>{`Then create a new banner content in `}<strong parentName="p">{`Marketing`}</strong>{` > `}<strong parentName="p">{`Banners`}</strong>{` as below screenshot:`}</p>
<p><img alt="Edit banner Promo Text on top left of header" src={require("../img/edit-banner-promo-text-on-top-left-header.png")} /></p>
<p><strong parentName="p">{`Banner Content`}</strong>{`: Click the `}<strong parentName="p">{`HTML`}</strong>{` button to open `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
<p>{`Use the editor below to generate HTML. Click `}<strong parentName="p">{`Export HTML`}</strong>{` button, copy & paste the generated HTML to `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
{/* <SupermarketTopHeaderBanner01 /> */}
<LeftHeaderContentBuilderComponent mdxType="LeftHeaderContentBuilderComponent" />
<p><em parentName="p"><strong parentName="em">{`Note:`}</strong>{` DO NOT remove `}<inlineCode parentName="em">{`emthemesModezBannersBlockTopHeaderBanner01`}</inlineCode>{`.`}</em></p>
<ul>
<li parentName="ul"><strong parentName="li">{`Show on Page`}</strong>{`: `}<inlineCode parentName="li">{`Search Results Page`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Location`}</strong>{`: `}<inlineCode parentName="li">{`Top of Page`}</inlineCode></li>
</ul>
<h2 {...{
      "id": "custom-links-on-the-header-right"
    }}>{`Custom Links on the header right`}</h2>
<p><img alt="Custom Links on Top Right of Header" src={require("../img/custom-links-on-top-right-header.png")} /></p>
<p>{`To display the custom links at this position, go to `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Header`}</strong>{` > `}<strong parentName="p">{`Top Bar`}</strong>{`, tick on `}<strong parentName="p">{`Show extra links`}</strong>{`, save & publish:`}</p>
<p><img alt="theme-editor-show-extra-links-topbar" src={require("../img/theme-editor-show-extra-links-topbar.png")} /></p>
<p>{`Then create a new banner content in `}<strong parentName="p">{`Marketing`}</strong>{` > `}<strong parentName="p">{`Banners`}</strong>{` as showing below:`}</p>
<p><img alt="Edit banner custom links on top right of header" src={require("../img/edit-banner-topbar-custom-links.png")} /></p>
<p><strong parentName="p">{`Banner Content`}</strong>{`: Click to the `}<strong parentName="p">{`HTML`}</strong>{` button to open `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
<p>{`Use the editor below to generate HTML. Click `}<strong parentName="p">{`Export HTML`}</strong>{` button, copy & paste the generated HTML to `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
{/* <SupermarketTopHeaderBanner02 /> */}
<RightHeaderContentBuilderComponent mdxType="RightHeaderContentBuilderComponent" />
<p><em parentName="p"><strong parentName="em">{`Note:`}</strong>{` DO NOT remove `}<inlineCode parentName="em">{`emthemesModezBannersBlockTopHeaderBanner02`}</inlineCode>{`.`}</em></p>
<ul>
<li parentName="ul"><strong parentName="li">{`Show on Page`}</strong>{`: `}<inlineCode parentName="li">{`Search Results Page`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Location`}</strong>{`: `}<inlineCode parentName="li">{`Top of Page`}</inlineCode></li>
</ul>
<h2 {...{
      "id": "social-media-icons"
    }}>{`Social Media Icons`}</h2>
<p><img alt="Social media icons on header" src={require("../img/home1-header-social-icons.png")} /></p>
<p>{`The social media icons group can be turned on/off in `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Social Media Icons`}</strong>{` > `}<strong parentName="p">{`Placement`}</strong>{` > `}<strong parentName="p">{`Top/Right`}</strong>{`:`}</p>
<p><img alt="Configure social icons on header" src={require("../img/theme-editor-social-icons-top.png")} /></p>
<p>{`To configure your social media links, go to `}<strong parentName="p">{`Storefront Design`}</strong>{` > `}<strong parentName="p">{`Design Options`}</strong>{` > `}<strong parentName="p">{`Social Media`}</strong>{` section:`}</p>
<p><img alt="Edit social media links" src={require("../img/edit-social-media-icons.png")} /></p>
<h2 {...{
      "id": "colors-customization"
    }}>{`Colors Customization`}</h2>
<p>{`To customize the header's colors, find the options showing below in Theme Editor:`}</p>
<p><img alt="Theme editor header" src={require("../img/theme-editor-header.png")} /></p>
<h2 {...{
      "id": "banner-below-header"
    }}>{`Banner below Header`}</h2>
<p><img alt="banner below header" src={require("../img/home1-banner-below-header.png")} /></p>
<p>{`You can enable this banner across all pages or on all other pages except Home Page in `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Banners`}</strong>{` > `}<strong parentName="p">{`Banner after header`}</strong>{`:`}</p>
<p><img alt="configure banner after header" src={require("../img/theme-editor-banner-after-header.png")} /></p>
<p>{`After enabled, you can edit banner content by go to `}<strong parentName="p">{`Marketing`}</strong>{` > `}<strong parentName="p">{`Banners`}</strong>{`, click `}<strong parentName="p">{`Create a Banner`}</strong>{` button. Input the fields as below:`}</p>
<ul>
<li parentName="ul"><strong parentName="li">{`Banner Name`}</strong>{`: whatever.`}</li>
<li parentName="ul"><strong parentName="li">{`Banner Content`}</strong>{`: click the `}<strong parentName="li">{`HTML`}</strong>{` button to open `}<strong parentName="li">{`HTML Source Editor`}</strong>{`.`}</li>
</ul>
<p>{`Use the editor below to generate HTML. Click `}<strong parentName="p">{`Export HTML`}</strong>{` button, copy & paste the generated HTML to `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
<BannerBelowHeaderBuilderComponent mdxType="BannerBelowHeaderBuilderComponent" />
<p>{`Remember to choose other fields as below:`}</p>
<ul>
<li parentName="ul"><strong parentName="li">{`Show on Page`}</strong>{`: `}<inlineCode parentName="li">{`Search Results Page`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Visible`}</strong>{`: Checked`}</li>
<li parentName="ul"><strong parentName="li">{`Location`}</strong>{`: `}<inlineCode parentName="li">{`Top of Page`}</inlineCode></li>
</ul>
<h2 {...{
      "id": "3-offer-banners-below-the-header"
    }}>{`3 offer banners below the header`}</h2>
<p><img alt="3-offer-banners-below-header" src={require("../img/3-offer-banners-below-header.png")} /></p>
<p>{`Go to `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Banners`}</strong>{` > `}<strong parentName="p">{`Banner after header`}</strong>{` > choose `}<strong parentName="p">{`Show on all pages`}</strong>{`.`}</p>
<p>{`Create a new banner in `}<strong parentName="p">{`Marketing`}</strong>{` > `}<strong parentName="p">{`Banners`}</strong>{`, In the content editor, click HTML button to open `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
<p>{`Use the editor below to generate HTML. Click `}<strong parentName="p">{`Export HTML`}</strong>{` button, copy & paste the generated HTML to `}<strong parentName="p">{`HTML Source Editor`}</strong>{`.`}</p>
<ThreeBannersBelowHeaderBuilderComponent mdxType="ThreeBannersBelowHeaderBuilderComponent" />
<p>{`Choose other fields as below:`}</p>
<ul>
<li parentName="ul"><strong parentName="li">{`Show on Page`}</strong>{`: `}<inlineCode parentName="li">{`Search Results Page`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Visible`}</strong>{`: Checked`}</li>
<li parentName="ul"><strong parentName="li">{`Location`}</strong>{`: `}<inlineCode parentName="li">{`Top of Page`}</inlineCode></li>
</ul>
<h2 {...{
      "id": "quick-search---keyword-suggestions"
    }}>{`Quick Search - Keyword Suggestions`}</h2>
<p>{`The keyword suggestions feature enhances the search experience by displaying popular keyword suggestions when users interact with the search box. This feature includes autocomplete functionality similar to Google Search and keyboard navigation support.`}</p>
<p><img alt="Keyword suggestions in action" src={require("../img/keyword-suggestions.jpg")} /></p>
<iframe width="560" height="315" src="https://www.youtube.com/embed/mMg9aPb5SJY" title="Quick Search - Keyword Suggestions" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
<h3 {...{
      "id": "quick-start"
    }}>{`Quick Start`}</h3>
<ol>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Generate keywords`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Go to `}<strong parentName="li"><a parentName="strong" {...{
                "href": "https://bc-tools.papathemes.com/"
              }}>{`BC Tools`}</a></strong>{` and click `}<strong parentName="li">{`"Keyword Extractor"`}</strong>{` menu item`}</li>
<li parentName="ul">{`Enter your store URL and extract keywords (includes free credits)`}</li>
<li parentName="ul">{`Download the generated CSV files`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Upload CSV files`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Upload the downloaded files to BigCommerce WebDAV `}<inlineCode parentName="li">{`/content/`}</inlineCode>{` folder`}</li>
<li parentName="ul">{`Or upload to your own server/CDN`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Enable feature`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Go to `}<strong parentName="li">{`Theme Editor`}</strong>{` > `}<strong parentName="li">{`Header`}</strong>{` > `}<strong parentName="li">{`Quick search`}</strong></li>
<li parentName="ul">{`Enable `}<strong parentName="li">{`"Enable keyword suggestions"`}</strong></li>
<li parentName="ul">{`Configure the CSV file paths`}</li>
<li parentName="ul">{`Save & Publish`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Test`}</strong>{`: Try searching on your storefront!`}</p>
</li>
</ol>
<h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
<ul>
<li parentName="ul"><strong parentName="li">{`Smart Display`}</strong>{`: Shows top 10 popular keywords when focusing on the search box`}</li>
<li parentName="ul"><strong parentName="li">{`Realtime Filtering`}</strong>{`: Updates suggestions as users type, matching keywords that start with the search query`}</li>
<li parentName="ul"><strong parentName="li">{`Inline Autocomplete`}</strong>{`: Like Google Search, displays suggested completion directly in the search input`}<ul parentName="li">
<li parentName="ul">{`Type "bo" → Shows "bo`}<strong parentName="li">{`ok`}</strong>{`" with "ok" dimmed`}</li>
<li parentName="ul">{`Press Right Arrow (→) to accept and continue suggesting`}</li>
</ul></li>
<li parentName="ul"><strong parentName="li">{`Keyboard Navigation`}</strong>{`:`}<ul parentName="li">
<li parentName="ul"><inlineCode parentName="li">{`→`}</inlineCode>{` (Right Arrow): Accept autocomplete suggestion`}</li>
<li parentName="ul"><inlineCode parentName="li">{`↑/↓`}</inlineCode>{`: Navigate between suggestions`}</li>
<li parentName="ul"><inlineCode parentName="li">{`Enter`}</inlineCode>{`: Select highlighted suggestion`}</li>
<li parentName="ul"><inlineCode parentName="li">{`Esc`}</inlineCode>{`: Clear selection and autocomplete`}</li>
</ul></li>
<li parentName="ul"><strong parentName="li">{`Responsive Design`}</strong>{`: Adapts to mobile and desktop layouts`}</li>
<li parentName="ul"><strong parentName="li">{`Smart Loading`}</strong>{`: Uses lazy loading for optimal performance`}</li>
</ul>
<h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
<h4 {...{
      "id": "enabledisable-the-feature"
    }}>{`Enable/Disable the Feature`}</h4>
<p>{`Go to `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Header`}</strong>{` > `}<strong parentName="p">{`Quick search`}</strong>{` section:`}</p>
<ol>
<li parentName="ol">{`Enable `}<strong parentName="li">{`Enable keyword suggestions`}</strong>{` checkbox`}</li>
<li parentName="ol">{`Configure CSV file paths (see below)`}</li>
<li parentName="ol">{`Save & Publish`}</li>
</ol>
<h4 {...{
      "id": "csv-file-configuration"
    }}>{`CSV File Configuration`}</h4>
<p>{`You can specify up to 3 CSV files containing keywords:`}</p>
<ul>
<li parentName="ul"><strong parentName="li">{`Keywords file 1`}</strong>{`: Single-word keywords (e.g., "laptop", "phone")`}</li>
<li parentName="ul"><strong parentName="li">{`Keywords file 2`}</strong>{`: Two-word keywords (e.g., "gaming laptop", "wireless mouse")`}</li>
<li parentName="ul"><strong parentName="li">{`Keywords file 3`}</strong>{`: Three+ word keywords (e.g., "best gaming laptop 2024")`}</li>
</ul>
<p><strong parentName="p">{`File Path Options:`}</strong></p>
<p>{`You can use either relative paths or full URLs:`}</p>
<pre><code parentName="pre" {...{}}>{`Relative path: /content/suggest-keywords-1.csv
Full URL: https://example.com/data/suggest-keywords-1.csv
`}</code></pre>
<p><strong parentName="p">{`Note about Lazy Loading:`}</strong></p>
<ul>
<li parentName="ul">{`If `}<strong parentName="li">{`any`}</strong>{` file uses a relative path, CSV files load only when users focus on search (lazy loading) - except on the search page where they load immediately`}</li>
<li parentName="ul">{`If `}<strong parentName="li">{`all`}</strong>{` files use full URLs, CSV files load immediately on page load`}</li>
<li parentName="ul">{`Lazy loading reduces traffic since BigCommerce servers don't support browser cache headers`}</li>
</ul>
<h4 {...{
      "id": "to-disable"
    }}>{`To Disable`}</h4>
<p><strong parentName="p">{`Method 1`}</strong>{`: Uncheck "Enable keyword suggestions" in Theme Editor`}</p>
<p><strong parentName="p">{`Method 2`}</strong>{`: Leave all 3 file paths empty`}</p>
<h3 {...{
      "id": "csv-file-format"
    }}>{`CSV File Format`}</h3>
<p>{`Each CSV file should have 2 columns `}<strong parentName="p">{`without a header row`}</strong>{`:`}</p>
<ol>
<li parentName="ol"><strong parentName="li">{`Keyword`}</strong>{` (text)`}</li>
<li parentName="ol"><strong parentName="li">{`Rank`}</strong>{` (number - `}<strong parentName="li">{`higher rank = better match, higher priority`}</strong>{`)`}</li>
</ol>
<p><strong parentName="p">{`Example CSV file:`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-csv"
      }}>{`laptop,80000
phone,70000
tablet,60000
computer,50000
monitor,40000
`}</code></pre>
<p><strong parentName="p">{`Important:`}</strong>{` Higher rank numbers mean the keyword will appear first in suggestions. Keywords are sorted by rank in descending order.`}</p>
<h3 {...{
      "id": "creating-csv-files"
    }}>{`Creating CSV Files`}</h3>
<h4 {...{
      "id": "method-1-use-the-keyword-extractor-tool-recommended"
    }}>{`Method 1: Use the Keyword Extractor Tool (Recommended)`}</h4>
<p>{`The easiest way to create keyword CSV files is to use our `}<strong parentName="p">{`Keyword Extractor`}</strong>{` tool:`}</p>
<p><strong parentName="p">{`Step-by-step instructions:`}</strong></p>
<ol>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Open BC Tools`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Go to `}<strong parentName="li"><a parentName="strong" {...{
                "href": "https://bc-tools.papathemes.com/"
              }}>{`https://bc-tools.papathemes.com/`}</a></strong></li>
<li parentName="ul">{`Click on the `}<strong parentName="li">{`"Keyword Extractor"`}</strong>{` menu item to access the tool`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Extract Keywords`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Enter your BigCommerce store URL in the input field`}</li>
<li parentName="ul">{`Click the extract button`}</li>
<li parentName="ul">{`The tool will automatically analyze your store's products and extract relevant keywords`}</li>
<li parentName="ul">{`Keywords will be organized by word count with appropriate rank values`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Download CSV Files`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Once extraction is complete, download the generated CSV files`}</li>
<li parentName="ul">{`You'll typically get 3 files:`}<ul parentName="li">
<li parentName="ul"><inlineCode parentName="li">{`suggest-keywords-1.csv`}</inlineCode>{` (single-word keywords)`}</li>
<li parentName="ul"><inlineCode parentName="li">{`suggest-keywords-2.csv`}</inlineCode>{` (two-word keywords)`}</li>
<li parentName="ul"><inlineCode parentName="li">{`suggest-keywords-3.csv`}</inlineCode>{` (three+ word keywords)`}</li>
</ul></li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Upload to Your Store`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">
<p parentName="li"><strong parentName="p">{`Option A - Upload to BigCommerce WebDAV`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Connect to your store via WebDAV`}</li>
<li parentName="ul">{`Create a `}<inlineCode parentName="li">{`/content/`}</inlineCode>{` folder if it doesn't exist`}</li>
<li parentName="ul">{`Upload the 3 CSV files to `}<inlineCode parentName="li">{`/content/`}</inlineCode>{` folder`}</li>
</ul>
</li>
<li parentName="ul">
<p parentName="li"><strong parentName="p">{`Option B - Upload to Your Own Server/CDN`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Upload the CSV files to your own hosting/CDN`}</li>
<li parentName="ul">{`Use the full URLs in Theme Editor settings (e.g., `}<inlineCode parentName="li">{`https://yourdomain.com/keywords/suggest-keywords-1.csv`}</inlineCode>{`)`}</li>
</ul>
</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Configure in Theme Editor`}</strong>{` (see Configuration section above)`}</p>
</li>
</ol>
<p>{`This tool analyzes your actual product data and generates keyword suggestions with appropriate rank values automatically.`}</p>
<p><strong parentName="p">{`Note:`}</strong>{` The Keyword Extractor tool includes a few free credits to extract keywords. If you need to extract more keywords beyond the free credits, you'll need to purchase additional credits.`}</p>
<h4 {...{
      "id": "method-2-create-manually"
    }}>{`Method 2: Create Manually`}</h4>
<p>{`If you prefer to create CSV files manually:`}</p>
<ol>
<li parentName="ol"><strong parentName="li">{`Create the CSV files`}</strong>{` on your computer using the format above`}</li>
<li parentName="ol">{`Use a spreadsheet program (Excel, Google Sheets) or text editor`}</li>
<li parentName="ol">{`Save as CSV format with 2 columns: keyword, rank (no header row)`}</li>
<li parentName="ol">{`Name your files:`}<ul parentName="li">
<li parentName="ul"><inlineCode parentName="li">{`suggest-keywords-1.csv`}</inlineCode>{` (single-word keywords)`}</li>
<li parentName="ul"><inlineCode parentName="li">{`suggest-keywords-2.csv`}</inlineCode>{` (two-word keywords)`}</li>
<li parentName="ul"><inlineCode parentName="li">{`suggest-keywords-3.csv`}</inlineCode>{` (three+ word keywords)`}</li>
</ul></li>
</ol>
<p><strong parentName="p">{`Then upload using one of these options:`}</strong></p>
<ul>
<li parentName="ul">
<p parentName="li"><strong parentName="p">{`Upload to BigCommerce WebDAV`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Connect to your store via WebDAV`}</li>
<li parentName="ul">{`Create a `}<inlineCode parentName="li">{`/content/`}</inlineCode>{` folder if it doesn't exist`}</li>
<li parentName="ul">{`Upload the 3 CSV files to the `}<inlineCode parentName="li">{`/content/`}</inlineCode>{` folder`}</li>
<li parentName="ul">{`Use relative paths in Theme Editor: `}<inlineCode parentName="li">{`/content/suggest-keywords-1.csv`}</inlineCode></li>
</ul>
</li>
<li parentName="ul">
<p parentName="li"><strong parentName="p">{`Upload to Your Own Server/CDN`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Upload to your hosting or CDN service`}</li>
<li parentName="ul">{`Use full URLs in Theme Editor: `}<inlineCode parentName="li">{`https://yourdomain.com/keywords/suggest-keywords-1.csv`}</inlineCode></li>
</ul>
</li>
</ul>
<p>{`After uploading, configure the file paths in `}<strong parentName="p">{`Theme Editor`}</strong>{` > `}<strong parentName="p">{`Header`}</strong>{` > `}<strong parentName="p">{`Quick search`}</strong>{` section.`}</p>
<p><strong parentName="p">{`Sample Data (based on actual demo data):`}</strong></p>
<p><strong parentName="p">{`suggest-keywords-1.csv`}</strong>{` (single words):`}</p>
<pre><code parentName="pre" {...{
        "className": "language-csv"
      }}>{`set,80023
usb,70042
travel,70002
new,60028
wireless,60016
original,60007
fashion,60004
men,60000
high,50044
bag,50013
phone,45000
laptop,40000
tablet,35000
computer,30000
monitor,25000
keyboard,20000
mouse,15000
camera,12000
watch,10000
shoes,8000
`}</code></pre>
<p><strong parentName="p">{`suggest-keywords-2.csv`}</strong>{` (two words):`}</p>
<pre><code parentName="pre" {...{
        "className": "language-csv"
      }}>{`micro sd,30007
high heels,30000
sd card,20010
card reader,20008
memory card,20007
gaming laptop,18000
wireless mouse,16000
bluetooth headphone,14000
mechanical keyboard,12000
usb cable,10000
running shoes,8000
smart watch,7000
leather bag,6000
phone case,5000
laptop stand,4000
`}</code></pre>
<p><strong parentName="p">{`suggest-keywords-3.csv`}</strong>{` (three+ words):`}</p>
<pre><code parentName="pre" {...{
        "className": "language-csv"
      }}>{`micro sd card,20006
breathable mesh men,20000
cotton baby hat,10001
baby hat scarf,10001
gaming laptop 2024,9000
wireless gaming mouse,8000
noise cancelling headphone,7000
mechanical keyboard rgb,6000
fast charging cable,5000
leather travel bag,4000
running shoes men,3000
smart watch women,2500
phone case clear,2000
laptop stand adjustable,1500
`}</code></pre>
<p><strong parentName="p">{`Live Examples:`}</strong>{` You can download actual working CSV files from the demo site:`}</p>
<ul>
<li parentName="ul"><a parentName="li" {...{
          "href": "http://supermarket-yellow-demo.mybigcommerce.com/content/suggest-keywords-1.csv"
        }}>{`suggest-keywords-1.csv`}</a></li>
<li parentName="ul"><a parentName="li" {...{
          "href": "http://supermarket-yellow-demo.mybigcommerce.com/content/suggest-keywords-2.csv"
        }}>{`suggest-keywords-2.csv`}</a></li>
<li parentName="ul"><a parentName="li" {...{
          "href": "http://supermarket-yellow-demo.mybigcommerce.com/content/suggest-keywords-3.csv"
        }}>{`suggest-keywords-3.csv`}</a></li>
</ul>
<h3 {...{
      "id": "how-it-works"
    }}>{`How It Works`}</h3>
<ol>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`On Page Load`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`If using full URLs: CSV files load with low priority (doesn't block page)`}</li>
<li parentName="ul">{`If using relative paths: Waits until user focuses on search box (or on search page)`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`On Search Focus`}</strong>{`: Displays top 10 keywords sorted by rank`}</p>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`While Typing`}</strong>{`:`}</p>
<ul parentName="li">
<li parentName="ul">{`Filters keywords that `}<strong parentName="li">{`start with`}</strong>{` the typed text`}</li>
<li parentName="ul">{`Shows inline autocomplete suggestion (first match)`}</li>
<li parentName="ul">{`Updates in realtime (debounced 100ms)`}</li>
</ul>
</li>
<li parentName="ol">
<p parentName="li"><strong parentName="p">{`Selecting Keyword`}</strong>{`: Fills the search box and triggers quick search`}</p>
</li>
</ol>
<h3 {...{
      "id": "advanced-configuration"
    }}>{`Advanced Configuration`}</h3>
<p>{`For advanced users who want to use external CDN or customize file paths, you can:`}</p>
<ol>
<li parentName="ol">{`Upload CSV files to your own CDN`}</li>
<li parentName="ol">{`Use full URLs in the Theme Editor settings`}</li>
<li parentName="ol">{`This enables immediate loading with browser caching support`}</li>
</ol>
<p><strong parentName="p">{`Example with CDN:`}</strong></p>
<pre><code parentName="pre" {...{}}>{`Keywords file 1: https://cdn.yourstore.com/keywords/single-words.csv
Keywords file 2: https://cdn.yourstore.com/keywords/two-words.csv
Keywords file 3: https://cdn.yourstore.com/keywords/three-words.csv
`}</code></pre>
<h3 {...{
      "id": "tips-for-best-results"
    }}>{`Tips for Best Results`}</h3>
<ol>
<li parentName="ol"><strong parentName="li">{`Use the Keyword Extractor Tool`}</strong>{`: Start with our `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://bc-tools.papathemes.com/"
          }}>{`Keyword Extractor`}</a></strong>{` to automatically generate keywords from your actual products - this is the fastest and most accurate way`}</li>
<li parentName="ol"><strong parentName="li">{`Rank Keywords by Popularity`}</strong>{`: Assign higher rank numbers to more popular search terms (e.g., "laptop,80000" appears before "mouse,15000")`}</li>
<li parentName="ol"><strong parentName="li">{`Use Meaningful Rank Gaps`}</strong>{`: Leave gaps between ranks (e.g., 80000, 70000, 60000) so you can easily insert new keywords later`}</li>
<li parentName="ol"><strong parentName="li">{`Organize by Word Count`}</strong>{`: Use the 3 files to separate keywords by length for better matching:`}<ul parentName="li">
<li parentName="ul">{`File 1: Single words ("laptop", "phone")`}</li>
<li parentName="ul">{`File 2: Two words ("gaming laptop", "wireless mouse")`}</li>
<li parentName="ul">{`File 3: Three+ words ("best gaming laptop 2024")`}</li>
</ul></li>
<li parentName="ol"><strong parentName="li">{`Base on Search Analytics`}</strong>{`: Use your store's actual search data to identify popular keywords`}</li>
<li parentName="ol"><strong parentName="li">{`Update Regularly`}</strong>{`: Refresh your keyword lists based on seasonal trends and new products`}</li>
<li parentName="ol"><strong parentName="li">{`Start Small`}</strong>{`: Begin with 20-30 keywords per file and expand as needed`}</li>
<li parentName="ol"><strong parentName="li">{`Test Thoroughly`}</strong>{`: After uploading CSV files, test on different devices to ensure smooth performance`}</li>
<li parentName="ol"><strong parentName="li">{`Match Your Products`}</strong>{`: Include keywords that actually match products in your store`}</li>
</ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      